<template>

  <div>
    <!-- 右键 -->
    <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
    <!-- 搜索 -->
    <div style="padding-bottom: 3px;">
      <!--<Input size="small" v-model="searchMsg" placeholder="搜索" style="width: 180px;"/>-->
      <!--      <Select-->
      <!--        v-model="searchMsg"-->
      <!--        size="small"-->
      <!--        filterable-->
      <!--        remote-->
      <!--        :remote-method="getSearchOption"-->
      <!--        style="width: 180px;"-->
      <!--        clearable-->
      <!--      >-->
      <!--        <Option v-for="(option, index) in SearchResultData" :value="option" :key="index">{{option}}</Option>-->
      <!--      </Select>-->
      <Input  size="small" clearable v-model="searchMsg" placeholder="车牌/主机名称/分组名称" style="width: 150px; margin-right: 3px;"></Input>

      <DatePicker type="daterange" size="small" placeholder="请选择时间" style="width: 180px;"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" style="margin-left:3px;" :disabled="listLoadding" @click="onFind">查询</Button>
      <Row style="margin-top: 3px;">
        <Checkbox size="small" v-model="showNormal">显示已恢复的记录</Checkbox>
      </Row>
    </div>
    <!-- 报表主页面 -->
    <div style="width: 100%;">
      <Table
        border
        size="small"
        :columns="columns"
        :data="data"
        highlight-row
        ref="table"
        @on-sort-change="onSortChange"
        @on-filter-change="filterChange"
        @contextmenu.prevent.native="onTableRightClick($event)"
        :height="tableHeight">
      </Table>
    </div>
    <!-- 蒙版 -->
    <div class="mb" v-if="listLoadding"></div>
    <!-- 分页控件 -->
    <Page :total="totalElements"
          :page-size="pagesize"
          :show-total="true"
          :current="pageIndex"
          @on-change="setPage"
          show-elevator
          show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
          style="text-align:right;margin-top:10px"/>
    <!-- 自定义显示列 -->
    <web-table-columns-modal
      :columnList.sync="columns"
      :tableName="$options.name"
      v-model="webTableColumnsModal">
    </web-table-columns-modal>
    <driver-card-add-processremark-modal v-model="DriverCardAddProcessremarkModal" :initValue="DriverCardAddProcessremarkModalId"
                                         @on-success="refreshPage"></driver-card-add-processremark-modal>

    <Modal v-model="setupVehicleParamsModal" width="600" title="设置车辆参数">
      <Form ref="setupVehicleParams" autoComplete="on" v-model="setupVehicleParams"
            class="card-box login-form">
        <FormItem>
          <label>注：如不修改的字段请留空</label>
        </FormItem>
        <FormItem prop="driverCardNum">
          <label style="display: inline-block; width: 100px;">司机卡号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverCardNum"
                 placeholder="请输入司机卡号">
          </Input>
        </FormItem>
        <FormItem prop="driverLicenseNum">
          <label style="display: inline-block; width: 100px;">驾驶证号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverLicenseNum"
                 placeholder="请输入驾驶证号">
          </Input>
        </FormItem>
        <FormItem prop="driverName">
          <label style="display: inline-block; width: 100px;">驾驶员名</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverName"
                 placeholder="请输入驾驶员名">
          </Input>
        </FormItem>
        <Button type="primary" @click="onCleanVehicleParams" style="margin-right: 5px;">清空</Button>
        <Button type="primary" @click="onSetupVehicleParams">发送</Button>
      </Form>
    </Modal>

    <Modal v-model="hikSetDriverCardModal" width="600" title="设置车辆参数">
      <Form ref="setupVehicleParams" autoComplete="on" v-model="setupVehicleParams"
            class="card-box login-form">
        <FormItem>
          <label>注：如不修改的字段请留空</label>
        </FormItem>
        <FormItem prop="driverCardNum">
          <label style="display: inline-block; width: 100px;">司机卡号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverCardNum"
                 placeholder="请输入司机卡号">
          </Input>
        </FormItem>
        <FormItem prop="driverLicenseNum">
          <label style="display: inline-block; width: 100px;">驾驶证号</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverLicenseNum"
                 placeholder="请输入驾驶证号">
          </Input>
        </FormItem>
        <FormItem prop="driverName">
          <label style="display: inline-block; width: 100px;">驾驶员名</label>
          <Input style="display: inline-block; width: 300px;" v-model="setupVehicleParams.driverName"
                 placeholder="请输入驾驶员名">
          </Input>
        </FormItem>
        <Button type="primary" @click="onCleanVehicleParams" style="margin-right: 5px;">清空</Button>
        <Button type="primary" @click="onSetupVehicleParams">发送</Button>
      </Form>
    </Modal>
  </div>

</template>

<script>
import Vue from 'vue'
import store from '../../store'
import { GPS } from '@/libs/positonUtils'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import DriverCardAddProcessremarkModal from '@/view/da/components/driver-card-add-processremark-modal'
function getWordsCount (val) {
  var bytesCount = 0
  for (var i = 0; i < val.length; i++) {
    var c = val.charAt(i)
    if (/^[\u0000-\u00ff]$/.test(c)) // 匹配双字节
    {
      bytesCount += 1
    } else {
      bytesCount += 2
    }
  }
  return bytesCount
}
export default {
  name: 'drivercarddatagroupsanalysis',
  components: {
    DriverCardAddProcessremarkModal
  },
  data () {
    return {
      showNormal: false,

      // Hik设置司机卡
      hikSetDriverCardModal: false,
      hikSetDriverCardId: null,

      // BSJ设置司机卡
      // <EXTBE1驾驶员代码,驾驶证代码,驾驶员名,车架号,车牌号,车牌分类,发动机号,身份证号AA>
      setupVehicleParamsModal: false,
      setupVehicleParams: {
        // id: null,
        terminalnum: null,
        driverCardNum: null, // 驾驶员代码
        driverLicenseNum: null, // 驾驶证代码
        driverName: null // 驾驶员名
        // vin: null, // 车架号
        // registrationNum: null, // 车牌号
        // vehicleTypeName: null, // 车牌分类
        // engineNum: null// 发动机号
      },

      // 追加备注
      DriverCardAddProcessremarkModal: false,
      DriverCardAddProcessremarkModalId: null,
      stateFilter: null,
      businessUserFilter: null,

      dateFilter: [],
      startDate: null,
      endDate: null,
      columns: [
        {
          title: 'id',
          key: 'id',
          width: 95,
          resizable: true,
          sortable: 'custom',
          align: 'center'
        },
        {
          title: '主机号',
          key: 'terminalNum',
          width: 120,
          resizable: true,
          align: 'center'
        },
        {
          title: '车架号',
          key: 'vin',
          width: 170,
          resizable: true,
          align: 'center',
          render: function (h, params) {
            let a = params.row.vehicleInfo.vin
            return h('div', a)
          }
        },
        {
          title: '车牌号',
          key: 'vehicleInfo',
          width: 100,
          resizable: true,
          align: 'center',
          render: function (h, params) {
            let a = params.row.vehicleInfo.registrationNum
            return h('div', a)
          }
        },
        {
          title: '司机姓名',
          key: 'collectDriverName',
          width: 100,
          resizable: true,
          // sortable: 'custom',
          align: 'center'
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'vehicleInfo',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfo.clientInfo) {
              display.push(h('div', '客户信息:' + params.row.vehicleInfo.clientInfo.name + '(' + params.row.vehicleInfo.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '客户信息:无'))
            }
            if (params.row.vehicleInfo.vehicleInfoGroup) {
              display.push(h('div', '分组:' + params.row.vehicleInfo.vehicleInfoGroup.name))
            } else {
              display.push(h('div', '分组:无'))
            }
            return h('div', display)
          }
        },
        {
          title: '车辆备注信息',
          key: 'vehicleInfo',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfo.remark) {
              display.push(h('div', '车辆备注:' + params.row.vehicleInfo.remark))
            } else {
              display.push(h('div', '车辆备注:无'))
            }
            return h('div', display)
          }
        },
        {
          title: '跟进业务员',
          key: 'vehicleInfo',
          width: 120,
          resizable: true,
          align: 'center',
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('vehicleInfo.businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.businessUser) {
                if (params.row.vehicleInfo.businessUser.realName) {
                  let b = params.row.vehicleInfo.businessUser.realName
                  return h('div', b)
                } else {
                  let b = params.row.vehicleInfo.businessUser.nickName
                  return h('div', b)
                }
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '创建时间',
          key: 'createDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '更新时间',
          key: 'updateDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '处理状态',
          resizable: true,
          key: 'processState',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '未处理', value: 1 },
            { label: '已处理', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('processState', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            let processState = params.row.processState
            if (processState === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '未处理')
              ])
            } else {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '已处理')
              ])
            }
          }
        },
        {
          title: '处理备注',
          key: 'processRemark',
          width: 200,
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          align: 'center'
        },
        {
          title: '历史处理备注',
          key: 'historyProcessRemark',
          width: 200,
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          align: 'center'
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 150,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.DriverCardAddProcessremarkModalId = params.row.id
                    this.DriverCardAddProcessremarkModal = true
                  }
                }
              }, '追加备注'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    //  判断设备生产商

                    this.driverCardDataResult = params.row
                    if (params.row.vehicleInfo.positioningDeviceInfos[0].positioningDeviceModel.manufacturer == '惠州博实结科技有限公司') {
                      this.setupVehicleParams.terminalnum = params.row.terminalNum
                      this.setupVehicleParams.manufacturer = '惠州博实结科技有限公司'
                      this.setupVehicleParamsModal = true
                    }
                    if (params.row.vehicleInfo.positioningDeviceInfos[0].positioningDeviceModel.manufacturer == '杭州海康汽车技术有限公司') {
                      // this.hikSetDriverCardId = params.row.id
                      this.setupVehicleParams.terminalnum = params.row.terminalNum
                      this.setupVehicleParams.manufacturer = '杭州海康汽车技术有限公司'
                      this.hikSetDriverCardModal = true
                    }
                  }
                }
              }, '写卡')
            ])
          }
        }
      ],
      data: [],
      tableHeight: 160,
      totalElements: null,
      pagesize: 12,
      sort: null,
      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      pageIndex: 1,
      listLoadding: false,
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],
      // 搜索关键词
      searchMsg: '',
      SearchResultData: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 窗口的大小自适应
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 100
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 100
      }

      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8] }
      }).then(() => {
        let renewalers = store.getters.get_User_GetAllUsersResult
        this.renewalers = renewalers.map(item => {
          return { label: item.realName, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName, value: item.id }
          })
          // this.columns[4].filters = this.renewalers
          // this.columns[11].filters = this.marketsales
          store.dispatch('SalesChannelServ_GetAll', {
            params: null,
            urlparams: null
          }).then(() => {
            let allSalesChannels = store.getters.get_SalesChannel_GetAllResult
            this.allSalesChannels = allSalesChannels.map(item => {
              return { label: item.name, value: item.id }
            })
            this.onColumnUpdate()
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    })

    // 初始化数据
    this.getData(1)
  },
  methods: {
    // 获取数据
    getData (pageIndex) {
      console.log('setPage' + pageIndex)
      this.pageIndex = pageIndex
      this.listLoadding = true

      let sortParam = null
      let queryParams = []
      let qo1 = null
      let qo2 = null
      let qo3 = []

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (!this.showNormal) {
        qo3.push(genQueryParam('processState', 'NEQ', 3))
      }
      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('updateDatetime', 'BTDT', this.startDate, this.endDate))
      }
      this.listLoadding = true
      store.dispatch('DriverCardDataResultServ_GetMyUserGroupPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          q: queryParams,
          keyword: this.searchMsg,
          ps: this.pageFilter,
          p: pageIndex,
          sort: sortParam
        }
      }).then(res => {
        console.log(res)
        this.listLoadding = false
        this.data = res.data.content
        this.totalElements = res.data.totalElements
        this.pagesize = res.data.pageable.pageSize
      }).catch(err => {
        console.log(err)
        this.listLoadding = false
      })
    },
    // 搜索
    onFind () {
      if (this.dateFilter.length==0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.getData(1)
    },
    // 分页
    setPage (pageIndex) {
      this.getData(pageIndex)
    },
    onSortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    filterChange () {
      this.setPage(1)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
    },
    /**
     * BSJ写卡功能
     */
    onCleanVehicleParams () {
      // this.setupVehicleParams.id = null
      this.setupVehicleParams.driverCardNum = null
      this.setupVehicleParams.driverLicenseNum = null
      this.setupVehicleParams.driverName = null
      this.setupVehicleParams.vin = null
      this.setupVehicleParams.registrationNum = null
      this.setupVehicleParams.vehicleTypeName = null
      this.setupVehicleParams.engineNum = null
    },
    onSetupVehicleParams () {
      console.log(this.setupVehicleParams.manufacturer)
      if (this.setupVehicleParams.manufacturer == '惠州博实结科技有限公司') {
        let cmd = '<EXTBE1'
        if (this.setupVehicleParams.driverCardNum) {
          let driverCardNum = this.setupVehicleParams.driverCardNum
          let spaceCount = 7 - getWordsCount(driverCardNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverCardNum = driverCardNum + ' '
            }
          }
          cmd = cmd + driverCardNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.driverLicenseNum) {
          let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
          let spaceCount = 18 - getWordsCount(driverLicenseNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverLicenseNum = driverLicenseNum + ' '
            }
          }
          cmd = cmd + driverLicenseNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.driverName) {
          let driverName = this.setupVehicleParams.driverName
          let spaceCount = 10 - getWordsCount(driverName)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverName = driverName + ' '
            }
          }
          cmd = cmd + driverName + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.vin) {
          let vin = this.setupVehicleParams.vin
          let spaceCount = 17 - getWordsCount(vin)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              vin = vin + ' '
            }
          }
          cmd = cmd + vin + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.registrationNum) {
          let registrationNum = this.setupVehicleParams.registrationNum
          let spaceCount = 12 - getWordsCount(registrationNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              registrationNum = registrationNum + ' '
            }
          }
          cmd = cmd + registrationNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.vehicleTypeName) {
          let vehicleTypeName = this.setupVehicleParams.vehicleTypeName
          let spaceCount = 12 - getWordsCount(vehicleTypeName)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              vehicleTypeName = vehicleTypeName + ' '
            }
          }
          cmd = cmd + vehicleTypeName + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.engineNum) {
          cmd = cmd + this.setupVehicleParams.engineNum + ','
        } else {
          cmd = cmd + ','
        }
        if (this.setupVehicleParams.driverLicenseNum) {
          let driverLicenseNum = this.setupVehicleParams.driverLicenseNum
          let spaceCount = 18 - getWordsCount(driverLicenseNum)
          if (spaceCount > 0) {
            for (var i = 0; i < spaceCount; i++) {
              driverLicenseNum = driverLicenseNum + ' '
            }
          }
          cmd = cmd + driverLicenseNum
        }
        cmd = cmd + 'AA>'
        store.dispatch('NetCommandServ_OnTerminalnumSendCommand', {
          params: { terminalnum: this.setupVehicleParams.terminalnum, content: cmd, urgent: true }
        }).then(() => {
          this.$Message.success('发送成功')
          this.driverCardDataResult.processRemark = '写卡'
          this.driverCardDataResult.processState = 3
          store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
            params: this.driverCardDataResult
          }).then(() => {
            this.refreshPage(this.pageFilter)
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }

      if (this.setupVehicleParams.manufacturer == '杭州海康汽车技术有限公司') {
        store.dispatch('NetCommandServ_OnTerminalnumSendCommand', {
          params: { terminalnum: this.setupVehicleParams.terminalnum, content: 'ICInfo:' + this.setupVehicleParams.driverCardNum + ',20990921,' + this.setupVehicleParams.driverLicenseNum + ',' + this.setupVehicleParams.driverName + ';A!!!', urgent: true }
        }).then(() => {
          this.$Message.success('发送成功')
          this.driverCardDataResult.processRemark = '写卡'
          this.driverCardDataResult.processState = 3
          store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
            params: this.driverCardDataResult
          }).then(() => {
            this.refreshPage(this.pageFilter)
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  }
}
</script>

<style scoped>
  .mb{
    position:absolute;
    top:0px;
    width:100%;
    height:100%;
    display: flex;
    left:0;
    align-items: center;
    justify-content: center;
    background: rgba(210, 216, 222, 0.5);
  }
</style>
